export const START_TOUR_REQUEST = "START_TOUR_REQUEST";
export const START_TOUR_SUCCESS = "START_TOUR_SUCCESS";
export const START_TOUR_ERROR = "START_TOUR_ERROR";

export const END_TOUR_REQUEST = "END_TOUR_REQUEST";
export const END_TOUR_SUCCESS = "END_TOUR_SUCCESS";
export const END_TOUR_ERROR = "END_TOUR_ERROR";